/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';
import React from 'react';

var RadioButtonIndicator = function RadioButtonIndicator(_ref) {
  var disabled = _ref.disabled,
      focused = _ref.focused,
      selected = _ref.selected,
      size = _ref.size;
  var theme = useTheme();
  var backgroundColors = theme.color.background.radioButton;
  var borderColors = theme.color.border.radioButton;
  var width = theme.size.width.radioButton[size];
  var height = theme.size.height.radioButton[size];
  var backgroundColor = backgroundColors.base;
  var borderColor = borderColors.base;

  if (disabled) {
    backgroundColor = backgroundColors.disabled;
    borderColor = borderColors.disabled;
  } else if (selected) {
    backgroundColor = backgroundColors.selected;
  }

  var styles = /*#__PURE__*/css({
    display: 'inline-flex',
    position: 'relative',
    width: width,
    height: height,
    borderWidth: selected ? width / 3 : 2,
    borderStyle: 'solid',
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    borderRadius: '50%',
    boxSizing: 'border-box',
    boxShadow: focused ? theme.shadow.focusRing : 'none',
    userSelect: 'none',
    verticalAlign: 'middle'
  }, process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  return jsx("span", {
    css: styles
  });
};

export default RadioButtonIndicator;